<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="custom_container pt-2  h-100p overflow-y-scroll">
        <div class="search-container">
            <!-- Top bar -->
            <div class="search-header">
                <div class="header-left">
                    <button class="back-button" (click)="onBackButtonClick()">
          Back
        </button>
                </div>
                <div class="header-center">
                    <h1 class="search-query">{{ selectedSearchResult?.query }}</h1>
                </div>
                <div class="header-right">
                    <!-- Search box -->
                    <div class="search-box">
                        <input class="search-input" type="text" placeholder="Search here" [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange()" />
                    </div>

                    <!-- Export -->
                    <!-- <div class="dropdown">
          <button class="export-button dropdown-toggle" type="button" id="exportDropdown" data-bs-toggle="dropdown"
            aria-expanded="false">
            Export
          </button>
          <ul class="dropdown-menu" aria-labelledby="exportDropdown">
            <li>
              <a class="dropdown-item export-item" (click)="onExportOptionClick('pdf')">
                Export as PDF
              </a>
            </li>
            <li>
              <a class="dropdown-item export-item" (click)="onExportOptionClick('docx')">
                Export as DOCX
              </a>
            </li>
          </ul>
        </div> -->
                </div>
            </div>

            <!-- Loader -->
            <div *ngIf="isLoadingResults" class="loading-container text-center my-3">
                <div class="spinner-border text-primary" role="status"></div>
                <p class="mt-2 text-main-color">Fetching results, please wait...</p>
            </div>


            <!-- Results -->
            <div class="result-parent-container">
                <div class="results-container" *ngIf="!loadingCompletedSearchResult">
                    <!-- No Results Message -->
                    <div class="no-results-message text-center my-5" *ngIf="searchResultsFiltered.length === 0">
                        <p class="text-light">No results found</p>
                    </div>

                    <!-- Results count -->
                    <div class="results-summary w-100 text-center" *ngIf="searchResultsFiltered.length > 0">
                        Here we got <span class="results-count">+{{ searchResultCount }}</span> results
                    </div>

                    <div class="result-card" *ngFor="let searchResultFiltered of searchResultsFiltered">
                        <div class="card-header">
                            <div class="platform-info">
                                <img class="platform-icon" [src]="searchResultFiltered?.logo" (error)="onLogoError($event)" />
                                <span class="platform-name">{{ searchResultFiltered?.name }}</span>
                            </div>
                            <div class="leak-info">
                                <span class="leak-record-info">
              <span class="leak-record-label">Leak Records:</span>
                                <span class="leak-record-count">{{ searchResultFiltered?.leak_data?.length || 0 }}</span>
                                </span>
                                <span class="leak-date-info">
              <span class="leak-date-label">Leak Date:</span>
                                <span class="leak-date-value">{{ searchResultFiltered?.leak_date ? (searchResultFiltered?.leak_date |
                date: 'dd/MM/yyyy') : 'N/A' }}</span>
                                </span>
                            </div>
                        </div>

                        <div class="card-body">
                            <div class="card-description">
                                {{ searchResultFiltered?.description }}
                            </div>

                            <div class="data-section" *ngFor="let leakData of searchResultFiltered?.leak_data; let i = index">
                                <div class="data-header">Data {{ i + 1 }}</div>
                                <div class="data-grid">
                                    <ng-container *ngFor="let field of leakData | keyvalue">
                                    <div class="data-row" *ngIf="!(field.value | leakFieldBlank)">
                                        <mat-icon class="field-icon" [attr.data-field]="field.key">{{ getFieldIcon($any(field.key)).icon }}</mat-icon>
                                        <div class="field-content">
                                            <span class="field-label">{{ formatFieldLabel(field.key) }}</span>
                                            <ul class="field-value field-value-list"
                                                *ngIf="(field.value | leakEmailItems:field.key) as items; else singleValue">
                                                <li *ngFor="let item of items">{{ item }}</li>
                                            </ul>
                                            <ng-template #singleValue>
                                                <span class="field-value">{{ field.value }}</span>
                                            </ng-template>
                                        </div>
                                    </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="notes-section" *ngIf="searchResultsFiltered.length > 0">
                        <div class="notes-header">
                            Add Notes
                        </div>

                        <div class="notes-content">
                            <textarea class="note-input" maxlength="300" placeholder="Notes" [(ngModel)]="notes"></textarea>
                            <div class="notes-footer">
                                <span class="character-count">{{ notes.length }}/300</span>
                                <button class="update-button" (click)="onUpdateNotesButtonClick()">
              Update Notes
            </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>